import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* createCodeBasic({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.codes.create.basic, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.createCodeBasicDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createCodeBasicFailed,
      handledErrors,
      endpoint: api.codes.create.basic.url
    });
  }
}

export const createCodeBasicSaga = takeEvery(types.CREATE_CODE_BASIC_REQUEST, createCodeBasic);